import React, { useState } from "react";
import MuiModal from "../../shares/MuiModal";
import CloseIcon from "@mui/icons-material/Close";
import { useForm } from "react-hook-form";
import MuiTextFieldHook from "../../shares/MuiTextFieldHook";
import MuiComboBox from "../../shares/MuiComboBox";
import useFetch from "../../../context/useFetch";
import { useUserData } from "../../../context/UserDataContext";
import { toast } from "react-toastify";
import MuiSelectHook from "../../shares/MuiSelectHook";
import { messageReceiver } from "../../../utils";
import MuiTextAreaHook from "../../shares/MuiTextAreaHook";
import MuiButton from "../../shares/MuiButton";
import MuiSelect from "../../shares/MuiSelect";

const AdminAddMessages = (props) => {
  const [postData, setPostData] = useState({});
  const [searchedCustomerText, setSearchedCustomerText] = useState("");
  const [adminCustomersList, setAdminCustomersList] = useState([]);
  const [selectedType, setSelectedType] = useState();
  const [selectedOption, setSelectedOption] = useState();
  const [selectedUser, setSelectedUser] = useState();

  const {
    register,
    handleSubmit,
    watch,
    setError,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {},
  });
  const addNotifApi = useFetch({
    method: "post",
    url: `Notif_Service`,
    data: postData,
    argFunc: (res) => {
      // /setAdminCustomersList(res);
      props.setOpenModal(false);
      props.getFunc.reFetch()
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const onSubmit = (data) => {
    setPostData({
      ...data,
      sender: userData.username,
      notif_type: selectedType,
      user:
        selectedType == "customer" || selectedType == "provider"
          ? selectedUser.user
          : null,
    });
    addNotifApi.reFetch();
  };
  const { userData } = useUserData();

  const getListOfCustomerApi = useFetch({
    method: "post",
    url: `User_Service/${userData.username}/search_user`,
    data: { name: searchedCustomerText, type: selectedType },
    argFunc: (res) => {
      setAdminCustomersList(res);
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const handleSearchedCustomerText = (text) => {
    setSearchedCustomerText(text);
    if (text.length >= 1) {
      getListOfCustomerApi.reFetch();
    }
  };

  return (
    <>
      <MuiModal
        openModal={props.openModal}
        setOpenModal={props.setOpenModal}
        width="w-3/5"
        isOverflow={true}
        isNotBackdropClick={true}
      >
        <div>
          <div className="close-modal-icon">
            <CloseIcon
              onClick={() => props.setOpenModal(false)}
              fontSize="large"
              color="secondary"
            />
          </div>

          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="grid md:grid-cols-3 gap-y-6 gap-x-4 mt-2">
              <div className="col1">
                <div className="mt-2">
                  <MuiTextFieldHook
                    id="outlined-basic"
                    label="موضوع پیام"
                    variant="outlined"
                    size="small"
                    name="title"
                    isLTR={true}
                    control={control}
                    register={{
                      required: {
                        value: true,
                        message: "موضوع را وارد کنید",
                      },
                    }}
                  />
                </div>
              </div>

              <div className="col2">
                <div className="mt-2">
                  <MuiSelect
                    size="small"
                    onChange={(e) => {
                      setSelectedUser();
                      setSelectedType(e.target.value);
                    }}
                    inputLabel="نحوه ارسال"
                    label="notif_type"
                    control={control}
                    name="notif_type"
                    register={{
                      required: {
                        value: true,
                        message: "نحوه ارسال را انتخاب کنید",
                      },
                    }}
                    labelId="sent_typel-label"
                    id="sent_type-select"
                    menuItems={messageReceiver}
                    fromApi={false}
                  />
                </div>
              </div>

              {(selectedType == "customer" || selectedType == "provider") && (
                <div className="col3">
                  <div className="mt-2">
                    <MuiComboBox
                      size="small"
                      label="گیرنده"
                      labelId="customer-search-label"
                      id="customer-search-select"
                      selectedUser={selectedUser}
                      setSelectedUser={setSelectedUser}
                      options={adminCustomersList}
                      placeholder="نام گیرنده پیام"
                      setSelectedOption={setSelectedOption}
                      setSearchText={handleSearchedCustomerText}
                      forUser
                      baseWithJustUser
                    />
                  </div>
                </div>
              )}
            </div>
            {/* <MuiTextAreaHook
              size="small"
              inputLabel="نحوه ارسال"
              label="sent_type"
              control={control}
              name="sent_type"
              register={{
                required: {
                  value: true,
                  message: "نحوه ارسال را انتخاب کنید",
                },
              }}
              labelId="sent_typel-label"
              id="sent_type-select"
              menuItems={messageReceiver}
              fromApi={false}
            /> */}
            <div className="mt-3">
              <MuiTextFieldHook
                id="outlined-basic"
                label="متن پیام"
                variant="outlined"
                size="small"
                name="description"
                isLTR={true}
                control={control}
                register={{
                  required: {
                    value: true,
                    message: "متن را وارد کنید",
                  },
                }}
              />
            </div>
            <div className="text-left w-full mt-2">
              <MuiButton
                withoutOnClick
                type="submit"
                variant="contained"
                color="success"
                text="ارسال"
                // disabled={AddCustomerApi.loading}
              />
            </div>
          </form>
        </div>
      </MuiModal>
    </>
  );
};

export default AdminAddMessages;
